import WrapperTemplate from "common/StaticsService";

class StaticsServiceLocalization extends WrapperTemplate {
    documentName = 'localization';
    collectionName = 'statics';
}

export default StaticsServiceLocalization;